import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import {
  FormInputComponent,
  InputComponentConfig,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { DefaultFormComponentId } from "@vendure/common/lib/shared-types";
import {
  CountryFragment,
  MultipleCountrySelectorComponent,
} from "./multiple-country-selector/multiple-country-selector.component";

@Component({
  imports: [SharedModule, MultipleCountrySelectorComponent],
  standalone: true,
  selector: "multiple-country-form-input",
  templateUrl: "./multiple-country-form-input.component.html",
  styleUrls: ["./multiple-country-form-input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleCountryFormInputComponent implements FormInputComponent {
  static readonly id = "multiple-country-form-input";
  readonly isListInput = false;
  readonly: boolean;
  formControl: UntypedFormControl;
  config: InputComponentConfig;

  valueTransformFn = (values: CountryFragment[]) => {
    console.log("values", values);

    const isUsedInConfigArg = this.config.__typename === "ConfigArgDefinition";
    if (isUsedInConfigArg) {
      return JSON.stringify(values.map((s) => s.code));
    } else {
      return values;
    }
  };

  operators = [
    { label: "common.operator-contains", value: "in" },
    { label: "common.operator-notContains", value: "notIn" },
  ];

  test() {
    console.log(this.formControl);

    // this.formControl.patchValue({
    //   test: "test",
    //   codes: this.formControl.value,
    // });

    // console.log(this.formControl);
  }

  onChangeOperator(operator: string) {
    let codes = [];

    if (this.formControl.value.codes) {
      codes = this.formControl.value.codes;
    } else if (this.formControl.value.length) {
      codes = this.formControl.value;
    }

    this.formControl.patchValue({
      operator: operator,
      codes: codes,
    });
  }

  change(items: any) {
    this.formControl.patchValue({
      operator: this.formControl.value.operator,
      codes: items,
    });
  }
}
